import { defineComponent as m, computed as n, openBlock as o, createElementBlock as r, Fragment as c, normalizeClass as t, createElementVNode as i, toDisplayString as d, createCommentVNode as a, renderSlot as u, createBlock as h, unref as f } from "vue";
import { getDropdownDividerStyleClasses as w } from "./novoui-vuejs66.js";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import v from "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
const _ = { class: "dropdown-headers-header" }, y = { class: "dropdown-headers-subheader" }, ae = /* @__PURE__ */ m({
  __name: "NDropdownSection",
  props: {
    header: { default: void 0 },
    subHeader: { default: void 0 },
    smallHeadline: { type: Boolean, default: !1 },
    horizontalHeadlines: { type: Boolean, default: !1 },
    divider: { default: void 0 },
    isLast: { type: Boolean, default: !1 }
  },
  setup(p) {
    const e = p, s = n(() => w(e.divider));
    return (l, H) => (o(), r(c, null, [
      e.header && e.subHeader ? (o(), r("div", {
        key: 0,
        class: t(["dropdown-headers", [{ "dropdown-headers-horizontal": e.horizontalHeadlines }]])
      }, [
        i("p", _, d(e.header), 1),
        i("p", y, d(e.subHeader), 1)
      ], 2)) : e.header ? (o(), r("p", {
        key: 1,
        class: t(["dropdown-header", [{ "dropdown-header-small": e.smallHeadline }]])
      }, d(e.header), 3)) : e.subHeader ? (o(), r("p", {
        key: 2,
        class: t(["dropdown-subheader", [{ "dropdown-header-small": e.smallHeadline }]])
      }, d(e.header), 3)) : a("", !0),
      u(l.$slots, "default"),
      e.divider && !e.isLast ? (o(), h(f(v), {
        key: 3,
        class: t(["dropdown-divider", s.value])
      }, null, 8, ["class"])) : a("", !0)
    ], 64));
  }
});
export {
  ae as default
};
